// query string parser that returns an array of key/value pairs
export const parseQueryString = (queryString: string): Map<string, string> => {
  const queryPairs = queryString.substring(1).split('&');
  return new Map(
    queryPairs.map((pair) => {
      const queryPair = pair.split('=');
      return [queryPair[0], queryPair[1]];
    })
  );
};

// parses query string and returns JSON string with all query string params as key:value pairs
export const convertQueryStringToJSON = (queryString: string) => {
  const queryPairs = queryString.substring(1).split('&');
  const queryStringObject = queryPairs.reduce(
    (metadata: object, currentPair: string) => {
      const queryPair = currentPair.split('=');
      return {
        ...metadata,
        [queryPair[0]]: queryPair[1],
      };
    },
    {}
  );
  return queryStringObject;
};
